import * as React from 'react';
import { useTooltipContext } from '@Utils/shared/components/RaidIdTooltip/tooltipContext';

const HEADER_HEIGHT = 55;

export function useGetElementCoords(ref: React.MutableRefObject<HTMLDivElement | null>) {
  const { setIsShow } = useTooltipContext();
  const [coords, setCoords] = React.useState<DOMRect>({} as DOMRect);

  React.useEffect(() => {
    function listener() {
      if (!ref.current) {
        return;
      }

      const coords = ref.current.getBoundingClientRect();

      if (coords.top <= HEADER_HEIGHT) {
        setIsShow(false);
      }

      setCoords(coords);
    }

    listener();

    document.addEventListener('scroll', listener);

    return () => {
      document.removeEventListener('scroll', listener);
    };
  }, [ref, setIsShow]);

  return coords;
}
